<template>
  <div>
    <div class="ticket-list" v-for="(item, index) in lists1" :key="index">
      <dl>
        <dt class="H" v-if="item.rewardType == 51"><b>{{ item.reward / 100 }}</b>折</dt>
        <dt class="H" v-if="item.rewardType == 53"><b>{{ item.reward / 100 }}</b>元</dt>
        <dt class="W" v-if="item.rewardType == 52"><b>{{ item.reward / 100 }}</b>元
          <p>满{{item.money / 100}}元可用</p></dt>
        <dd><b>{{ item.rewardName }}</b>
        <div v-if="item.useTimeType==1">
            <p v-if="item.rewardType == 51">有效期至{{substrFun(item.useTimeEnd)}}</p>
            <p v-if="item.rewardType == 52||item.rewardType == 53">
            {{substrFun(item.useTimeStart)}}-{{substrFun(item.useTimeEnd)}}</p>
        </div>
          <div v-if="item.useTimeType==2">
           <p>领取后{{item.useTimeDays}}天后有效</p> 
        </div>
        </dd>
      </dl>
      <div class="ticket-tips">
        <div class="title"><span @click="showFont(item)">查看详情</span><b>使用说明</b></div>
        <p>可用时段：{{item.useTimeLimit==0?'不限':timeFun(item.useTime)}}</p>
        <p v-if="item.rewardType == 51">最高减{{item.highestMoney / 100}}元 ; 满{{item.money /
          100}}元可用</p>
        <div class="show-font" v-if="item.show">
          <p>使用规则：</p>
          <p v-html="item.content"></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: ['lists'],
    data() {
      return {
        lists1: [],
        activeIndex: -1,//初始化点击的索引值
      };
    },
    watch: {
      'lists': {
        handler(val) {
          let newArr = val.map(obj => {
            return {
              ...obj,
              show: false,
            };
          });
          this.lists1 = newArr;
          // this.$nextTick(() => {
          //   this.$emit('bottomScroll')
          // })
        },
        deep: true,
        immediate: true,
      },
    },
    methods: {
      showFont(item) {
        item.show = !item.show;
      },
      substrFun(str) {
        return str.substring(0, str.length - 3);
      },
      timeFun(val) {
        let arr = JSON.parse(val);
        let str = '';
        let i;
        for (i = 0; i < arr.length; i++) {
          str += arr[i].useTimeStart;
          str += '-';
          str += arr[i].useTimeEnd;
          str += '，';
        }
        return str.substring(0, str.length - 1);
      },
    }
  };
</script>
<style lang="less" scoped>
  .ticket-list {
    background: rgba(234, 234, 234, 0.43);
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 20px;

    dl {
      background: #FFCDA8;
      border-radius: 6px;
      padding: 4px;
      box-sizing: border-box;
      height: 84px;

      dt {
        width: 93px;
        text-align: center;
        float: left;
        font-size: 14px;
        font-weight: 600;
        color: #DF602F;

        b {
          font-size: 33px;
          font-weight: bold;
          color: #DF602F;
        }
      }

      dt.H {
        b {
          line-height: 84px;
        }
      }

      dt.W {
        padding-top: 10px;

        b {
        }

        p {
          font-size: 12px;
          font-weight: 500;
          color: #E77A50;
          line-height: 17px;
          padding-top: 4px;
        }
      }

      dt.H {
        width: 93px;
        text-align: center;
        float: left;
        font-size: 14px;
        font-weight: 600;
        color: #DF602F;

        b {
          font-size: 33px;
          font-weight: bold;
          color: #DF602F;
          line-height: 84px;
        }
      }


      dd {
        margin-left: 93px;
        font-size: 14px;
        font-weight: 600;
        color: #333333;
        line-height: 20px;
        background: white;
        height: 76px;
        padding: 8px 12px;
        box-sizing: border-box;
        border-radius: 0 6px 6px 0;

        p {
          font-size: 11px;
          font-weight: 400;
          color: #E77A50;
          line-height: 16px;
          padding-top: 5px;
        }
      }
    }

    .ticket-tips {
      padding: 8px 10px;

      .title {
        span {
          float: right;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
          line-height: 18px;
          background: url("../../../../assets/img/icon-down.png") no-repeat right center;
          padding-right: 18px;
        }

        span.cur {
          background: url("../../../../assets/img/icon-up.png");
        }
      }

      b {
        font-size: 12px;
        font-weight: bold;
        color: #333333;
        line-height: 18px;
        padding-bottom: 6px;
      }

      p {
        font-size: 11px;
        font-weight: 400;
        color: #666666;
        line-height: 16px;
      }

      .show-font {
        padding-top: 6px;
      }
    }
  }
</style>
